import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import { LANGUAGES, usePreferencesStore } from "@/preferences-store";

export const i18n = createInstance();

// Apenas seleção nesta etapa: não carregamos traduções nem alteramos o lang
// do documento enquanto o conteúdo real da interface continua em português.
void i18n.use(initReactI18next).init({
  lng: usePreferencesStore.getState().language,
  supportedLngs: [...LANGUAGES],
  fallbackLng: "pt-BR",
  resources: {
    "pt-BR": { translation: {} },
    es: { translation: {} },
    en: { translation: {} },
  },
  initAsync: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

const unsubscribe = usePreferencesStore.subscribe((state, previous) => {
  if (state.language !== previous.language) void i18n.changeLanguage(state.language);
});

if (import.meta.hot) import.meta.hot.dispose(unsubscribe);
